<div class="center">
    <div>
        <p class="not-found-text">404</p>
        <p>К сожалению, страница не существует</p>
    </div>
</div>
